import React from 'react'

function Warning2() {
    return (
        <svg width="16"
         height="15" 
         viewBox="0 0 16 15"
          fill="none" 
          xmlns="http://www.w3.org/2000/svg">
<path d="M0 15H16L8 0L0 15Z" fill="#F26901"/>
<path d="M8.72725 12.6317H7.27271V11.0527H8.72725V12.6317Z" fill="white"/>
<path d="M8.72725 9.47369H7.27271V6.3158H8.72725V9.47369Z" fill="white"/>
</svg>

    )
}

export default Warning2
